<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Session
    </button>

    <a-modal v-model="visible" title="Add a new session">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit">Add Session</a-button>
      </template>

      <a-form class="mb-4 row" :form="form">
        <a-form-item label="Start Date" class="col-md-6">
          <a-date-picker
              v-decorator="[
              'start_date',
              {rules: [{ required: true, message: 'Please input a start date' }], initialValue: moment()},
              ]"
              :format=dateFormat />
        </a-form-item>
        <a-form-item label="End Date" class="col-md-6">
          <a-date-picker
              v-decorator="[
              'end_date',
              {rules: [{ required: true, message: 'Please input an end date' }], initialValue: moment().add(1, 'Y')},
              ]"
              :format=dateFormat />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AddSession',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  methods: {
    moment,
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure?`,
            content: `Click on the OK button to add the new session!`,
            onOk: () => {
              this.$http
                .post('/api/session', {
                  start_date: moment(values.start_date).format('YYYY-MM-DD'),
                  end_date: moment(values.end_date).format('YYYY-MM-DD'),
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Session successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
